<template>
	<base-modal :show="!!error" title="An error occurred" @close="handleError">
		<p>{{ error }}</p>
	</base-modal>
	<div class="card mt-5 text-info" style="background-color: #263238">
		<div class="card-body">
			<h1 class="card-title border-bottom mb-5">Your Info</h1>
			<p v-if="userData1">{{ userData1.email }}</p>
			<p>{{ userData1.league }}</p>
			<p>{{ userData1.division }} {{ userData1.team }}</p>
			<form @submit.prevent="submitUserInfoForm">
				<div class="row g-2">
					<div class="col-md">
						<div class="form-floating">
							<input
								type="text"
								id="floatingFName"
								class="form-control"
								placeholder="First Name"
								v-model.trim="signUpFName.val"
							/>
							<label for="floatingFName">First Name</label>
						</div>
					</div>
					<div class="col-md">
						<div class="form-floating">
							<input
								type="text"
								class="form-control"
								id="floatingLName"
								placeholder="Last Name"
								v-model.trim="signUpLName.val"
							/>
							<label for="floatingLName">Last Name</label>
						</div>
					</div>
					<div class="form-floating">
						<select class="form-select" id="floatingSelectGrid" v-model="userType.val">
							<option value="Coach">Coach</option>
							<option value="Player">Player</option>
							<option :disabled="hasLeagueManager === true" value="League Manager">
								League Manager<span v-if="hasLeagueManager"> is filled!</span>
							</option>
							<option value="Family">Family Member</option>
						</select>
						<label for="floatingSelectGrid">You are a...</label>
					</div>
				</div>
				<div class="mt-2">
					<button :disabled="isLoading" class="btn btn-outline-info btn-lg">
						<div v-show="isLoading">
							<i class="fa-solid fa-baseball fa-spin"></i>
							Loading...
						</div>
						<div v-show="!isLoading">Finish</div>
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	props: ['userData1'],
	emits: ['user-info-step-complete', 'user-info'],
	data() {
		return {
			userType: {
				val: '',
				isValid: true,
			},
			signUpFName: {
				val: '',
				isValid: true,
			},
			signUpLName: {
				val: '',
				isValid: true,
			},
			formIsValid: true,
			error: null,
			isLoading: false,
			hasLeagueManager: false,
		};
	},
	created() {
		this.loadUsers();
		if (this.userData1.league !== '') {
			setTimeout(() => {
				this.hasManager();
			}, 500);
		}
	},
	methods: {
		hasManager() {
			const allUsers = this.$store.getters.allUsers;
			const exists = allUsers.filter(
				(i) => i.userType === 'League Manager' && i.leagueId === this.userData1.leagueId
			);
			if (exists.length > 0) {
				this.hasLeagueManager = true;
			}
			if (this.userData1.leagueId === '0000000001') {
				this.hasLeagueManager = true
			}
		},
		submitUserInfoForm() {
			const payload = {
				userType: this.userType.val,
				firstName: this.signUpFName.val,
				lastName: this.signUpLName.val,
			};

			try {
				this.$emit('user-info', payload);
				this.$emit('user-info-step-complete');
			} catch (err) {
				this.error = err.message || 'Set user info failed... Try again.';
			}
		},
		async loadUsers() {
			try {
				this.isLoading = true;
				await this.$store.dispatch('fetchUsers');
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			this.isLoading = false;
		},
		handleError() {
			this.error = null;
		},
	},
};
</script>
